export default "__VITE_ASSET__KlB2$kl2__"